export default {
  'repository': 'https://github.com/rowanwins/vue-dropzone',
  'branch': 'master',
  'docSource': 'docs/src/pages'
}
